import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CaptchaService} from '@iw-shop/captcha/services/captcha.service';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {AuthenticationService} from '@iw-shop/core/services/authentication.service';
import {setAccessExpire} from '@store/actions/storage.action';

@Component({
    selector: 'iw-shop-captcha-without-captcha',
    standalone: false,
    templateUrl: './captcha-without-captcha.component.html',
    styleUrls: ['./captcha-without-captcha.component.scss']
})
export class CaptchaWithoutCaptchaComponent implements OnInit {

    @Input() error: boolean = false;

    @Output() isVerified = new EventEmitter<boolean>();

    loading: boolean = false;
    verified: boolean = false;


    constructor(private store: Store<AppState>, private captchaService: CaptchaService, private authenticationService: AuthenticationService) {
    }

    ngOnInit(): void {
        if (this.authenticationService.isAccessTokenExpired(1)) {
            this.verified = false;
        } else {
            this.verified = true;
        }
        this.isVerified.emit(this.verified);
    }


    verify() {
        this.loading = true;
        // Boje
        this.captchaService.verify('lXvHx', 'ajWWP').subscribe(
            {
                next: (r) => {
                    if (r.result?.captcha) {
                        this.store.dispatch(setAccessExpire({
                            expiredIn: r.result.captcha.data.expiredIn
                        }));
                        this.authenticationService.setAccessTokenCookie();
                    }
                    this.loading = false;
                    this.verified = true;
                    this.isVerified.emit(this.verified);
                },
                error: (e) => {
                    console.log(e);
                    this.loading = false;
                }
            }
        )
    }

}
